// The website reports to its own PostHog project, "MicroPlastics Web" (579748),
// and never to the app's project in the "Microplastics Mobile" organization
// (503547). From 2026-09-14 to 2026-09-21 NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN held
// the app's token, so every website pageview landed in the app's analytics and
// outnumbered real app events about 15 to 1. Project tokens are public (they
// ship in the browser bundle), so naming them here exposes nothing.
export const WEB_POSTHOG_PROJECT_TOKEN = 'phc_mcxRbvF6PzbN6DDe8Hjf39DtAnARzzRwuzkMQYedd8UT'
export const MOBILE_APP_POSTHOG_PROJECT_TOKEN = 'phc_wxf5QQaqjTKbDwfQq4CVBJz89d85Vff2V66T32bFNgFE'

/**
 * An unset token keeps PostHog off, which is what local development and
 * preview builds rely on. The app's token is never accepted: it is swapped for
 * the web project's, so pasting the wrong value cannot send website traffic
 * into the app's data again.
 */
export function resolveWebPostHogToken(configured: string | undefined): string | undefined {
  const token = configured?.trim()
  if (!token) return undefined
  return token === MOBILE_APP_POSTHOG_PROJECT_TOKEN ? WEB_POSTHOG_PROJECT_TOKEN : token
}
